import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SiteHeader from "@/components/site/SiteHeader";
import Footer from "@/components/site/Footer";

/* ------------------------------------------------------------------
   SiteLayout — wraps non-homepage routes with the global header
   and footer. Project galleries (`/work/:slug`) and the homepage
   intentionally do NOT use this layout: the homepage runs its own
   animated nav from the hero, and project galleries rely on their
   immersive slide-based prev/next chrome.
   ------------------------------------------------------------------ */
export default function SiteLayout() {
  const { pathname } = useLocation();

  // SPA navigations should always land at the top of the new page,
  // never restore a prior scroll position. The previous in-page
  // back links handled this implicitly via their own onMount
  // effects; we centralise it here now.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <SiteHeader />
      <Outlet />
      <Footer />
    </>
  );
}
